import { Button } from "@tremor/react";
import { LORA, MQTT } from "./wizard";

const OPTIONS = [
  {
    value: LORA,
    title: "LoRaWAN",
    badge: "Device catalog",
    text: "Long-range sensors that report through The Things Network, ChirpStack or Helium.",
    needs: "Needs: DevEUI · a source",
  },
  {
    value: MQTT,
    title: "MQTT",
    text: "Your own hardware or code — Arduino, ESP32, Raspberry Pi — publishing straight to Zafron's broker.",
    needs: "Needs: nothing, we generate credentials",
  },
];

export default function ProtocolStep({ protocol, onSelect, onTrySimulator, simulatorBusy, simulatorError }) {
  return (
    <section>
      <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-50">How does it connect?</h2>
      <p className="mt-1 text-gray-600 dark:text-gray-400">You can change this later only by re-adding the device.</p>
      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {OPTIONS.map((o) => (
          <button
            key={o.value}
            type="button"
            aria-pressed={protocol === o.value}
            onClick={() => onSelect(o.value)}
            disabled={simulatorBusy}
            className={`rounded-xl border bg-white dark:bg-gray-900 p-6 text-left disabled:cursor-not-allowed disabled:opacity-50 ${
              protocol === o.value ? "border-blue-600 ring-2 ring-blue-100 dark:ring-blue-500/30" : "border-gray-200 dark:border-gray-800 hover:border-gray-400"
            }`}
          >
            <span className="flex items-center justify-between">
              <span className="text-xl font-semibold text-gray-900 dark:text-gray-50">{o.title}</span>
              {o.badge && (
                <span className="rounded-full bg-blue-50 dark:bg-blue-950/40 px-3 py-1 text-xs font-medium text-blue-700 dark:text-blue-300">{o.badge}</span>
              )}
            </span>
            <span className="mt-3 block text-gray-600 dark:text-gray-400">{o.text}</span>
            <span className="mt-4 block font-mono text-xs text-gray-500 dark:text-gray-400">{o.needs}</span>
          </button>
        ))}
      </div>
      <div className="mt-4 flex items-center justify-between rounded-xl border border-dashed border-gray-300 dark:border-gray-800 px-6 py-4">
        <span className="text-gray-700 dark:text-gray-300">
          <b>No hardware yet?</b> Create a simulated device and send sample data.
          {simulatorError && <span role="alert" className="ml-2 text-red-600 dark:text-red-400">{simulatorError}</span>}
        </span>
        <Button variant="secondary" onClick={onTrySimulator} loading={simulatorBusy}>
          Try the simulator
        </Button>
      </div>
    </section>
  );
}
